
const goldOptions = [
  "9K",
  "10K",
  "12K",
  "14K",
  "16K",
  "17K",
  "18K",
  "19K",
  "20K",
  "22K",
  "23.995K",
];

const silverOptions = ["SIL700", "SIL925", "SIL930", "SIL1000"];

const platinumOptions = ["PT850", "PT900", "PT950", "PT1000"];

const columnData = [
  /*{ label: "Id", accessor: "_id", sortable: true },*/
  { label: "Name", accessor: "firstname", sortable: true },
  { label: "Email", accessor: "email", sortable: true },
  { label: "SubareaId", accessor: "SubareaId", sortable: true },
  { label: "Role", accessor: "role", sortable: true },
  { label: "Status", accessor: "status", sortable: true },
  { label: "Date", accessor: "updatedAt", sortable: false },
  { label: "Action", accessor: "_id", sortable: false },
];

const rulesColumnData = [
  { label: "Id", accessor: "id", sortable: true },
  { label: "Full Name", accessor: "full_name", sortable: true },
  { label: "Email", accessor: "email", sortable: false },
  { label: "Gender", accessor: "gender", sortable: true },
  { label: "Age", accessor: "age", sortable: true },
  { label: "Start date", accessor: "start_date", sortable: true },
];

const logsColumnData = [
  { label: "Software", accessor: "software", sortable: true },
  { label: "DataTime", accessor: "logDataTime", sortable: true },
  { label: "From", accessor: "logFrom", sortable: true },
  { label: "Validation", accessor: "validationChecked", sortable: true },
  { label: "Status", accessor: "logType", sortable: true },
  { label: "Action", accessor: "logMessage", sortable: false },
  // { label: "logText", accessor: "logText", sortable: false },
];

const columnPricingTableData = [
  { label: "Pricing No", accessor: "pricingNo", sortable: true },
  { label: "Pricing Date", accessor: "pricingDate", sortable: true },
  { label: "Created By", accessor: "createdBy", sortable: true },
  { label: "CSC Name", accessor: "loggedCsc", sortable: true },
  { label: "Pricing For", accessor: "pricingFor", sortable: true },
  { label: "Customer Code", accessor: "customerCode", sortable: true },
  { label: "Factory Code", accessor: "factoryCode", sortable: true },
  { label: "Currency", accessor: "currency", sortable: true },
  { label: "Count", accessor: "count", sortable: true },
  { label: "Action", accessor: "_id", sortable: true },
];

const caratNonEditableList = ["Diamond"];
const lotCodeNonEditableList = ["Labour"];

const factoryCodeList = [
  {
    value: "CNPY_C02",
    label: "CNPY C02",
  },
  {
    value: "IKR06",
    label: "IKR06",
  },
  {
    value: "TCF_FAC",
    label: "TCF_FAC",
  },
  {
    value: "C1#KCJ",
    label: "C1#KCJ",
  },
  {
    value: "CNPY_C03",
    label: "CNPY C03",
  },
  {
    value: "CNPY_NHP_COMM",
    label: "CNPY NHP COMM",
  },
];

const unitList = [
  {
    label: "GM",
    value: "GM",
  },
  {
    label: "OZ",
    value: "OZ",
  },
];

const metalColorList = [
  {
    label: "YELLOW",
    value: "YELLOW",
  },
  {
    label: "WHITE",
    value: "WHITE",
  },
  {
    label: "PINK",
    value: "PINK",
  },
  // {
  //     label: "ROSE",
  //     value: "ROSE",
  // },
];

const currencyList = [
  {
    label: "USD",
    value: "USD",
  },
  {
    label: "INR",
    value: "INR",
  },
];

const pricingNoList = [
  {
    label: "Style",
    value: "STYLE",
  },
  {
    label: "Style Stone",
    value: "STYLE_STONE",
  },
  {
    label: "Design",
    value: "DESIGN",
  },
  {
    label: "Design Stone",
    value: "DESIGN_STONE",
  },
];

const pricingQualityList = [
  {
    label: "Internal",
    value: "INTERNALQUALITY",
  },

  {
    label: "International",
    value: "INTERNATIONALQUALITY",
  },
];

const qualityOptionList = [
  {
    label: "Group",
    value: "QUALITYGROUP",
  },
  {
    label: "Internal",
    value: "INTERNALQUALITY",
  },

  {
    label: "International",
    value: "INTERNATIONALQUALITY",
  },
];

const booleanList = ["True", "False"];

const statusList = [
  {
    label: "Success",
    value: "success",
  },
  {
    label: "Failure",
    value: "failure",
  },
];

const paginationList = [
  {
    label: "25 per page",
    value: "25",
  },
  {
    label: "50 per page",
    value: "50",
  },
  {
    label: "100 per page",
    value: "100",
  },
  {
    label: "200 per page",
    value: "200",
  },
  {
    label: "400 per page",
    value: "400",
  },
];

const softwareOptions = [
  { value: "", label: "All" },
  { value: "EIS", label: "EIS" },
  { value: "DIS", label: "DIS" },
  { value: "DMS", label: "DMS" }
];

const internalQulityList = [
  { value: "SI2-SI3/TLB(C3)", label: "SI2-SI3/TLB(C3)" },
  { value: "R4CB", label: "R4CB" },
  { value: "M1CB", label: "M1CB" },
  { value: "R3G", label: "R3G" },
  { value: "SI", label: "SI" },
  { value: "R3AA", label: "R3AA" },
  { value: "R1GB", label: "R1GB" },
  { value: "O3B", label: "O3B" },
  { value: "O1B", label: "O1B" },
  { value: "P1D", label: "P1D" },
  { value: "M1A", label: "M1A" },
  { value: "AGR1E", label: "AGR1E" },
  { value: "R7B", label: "R7B" },
  { value: "R4D", label: "R4D" },
  { value: "IDCR1F", label: "IDCR1F" },
  { value: "R2B", label: "R2B" },
  { value: "R8E", label: "R8E" },
  { value: "P4B", label: "P4B" },
  { value: "T1A", label: "T1A" },
  { value: "T1C", label: "T1C" },
  { value: "B4B", label: "B4B" },
  { value: "E1-02(B)", label: "E1-02(B)" },
  { value: "USR1B", label: "USR1B" },
  { value: "AGKR59A", label: "AGKR59A" },
  { value: "T1C-L", label: "T1C-L" },
  { value: "O1Z", label: "O1Z" },
  { value: "O1A", label: "O1A" },
  { value: "KO1C", label: "KO1C" },
  { value: "KO1B", label: "KO1B" },
  { value: "KS1B", label: "KS1B" },
  { value: "C1B", label: "C1B" },
  { value: "HIR1C", label: "HIR1C" },
  { value: "B1E", label: "B1E" },
  { value: "M1D", label: "M1D" },
  { value: "R3B", label: "R3B" },
  { value: "R1C", label: "R1C" },
  { value: "R1AA", label: "R1AA" },
  { value: "R3AAA", label: "R3AAA" },
  { value: "R1AAAA", label: "R1AAAA" },
  { value: "A1", label: "A1" },
  { value: "P4C", label: "P4C" },
  { value: "T1BC-L", label: "T1BC-L" },
  { value: "O3CL", label: "O3CL" },
  { value: "R8AAA", label: "R8AAA" },
  { value: "BNP1B", label: "BNP1B" },
  { value: "R1BB", label: "R1BB" },
  { value: "R1CBG", label: "R1CBG" },
  { value: "R4DB", label: "R4DB" },
  { value: "P7B", label: "P7B" },
  { value: "KA1B", label: "KA1B" },
  { value: "KP1C", label: "KP1C" },
  { value: "P1C-B", label: "P1C-B" },
  { value: "HI-VS", label: "HI-VS" },
  { value: "D1C", label: "D1C" },
  { value: "S1CL", label: "S1CL" },
  { value: "P1CL", label: "P1CL" },
  { value: "IDCR1E", label: "IDCR1E" },
  { value: "R7AAA", label: "R7AAA" },
  { value: "R8B", label: "R8B" },
  { value: "R4A", label: "R4A" },
  { value: "R5B", label: "R5B" },
  { value: "R2D", label: "R2D" },
  { value: "P4CL", label: "P4CL" },
  { value: "R1H", label: "R1H" },
  { value: "R1I", label: "R1I" },
  { value: "S3C", label: "S3C" },
  { value: "BNB1B", label: "BNB1B" },
  { value: "I1", label: "I1" },
  { value: "AGR59", label: "AGR59" },
  { value: "S1CB", label: "S1CB" },
  { value: "CUSDIA", label: "CUSDIA" },
  { value: "NA", label: "NA" },
  { value: "R1B", label: "R1B" },
  { value: "R1E", label: "R1E" },
  { value: "O3C", label: "O3C" },
  { value: "O1CB", label: "O1CB" },
  { value: "M4C", label: "M4C" },
  { value: "R4B", label: "R4B" },
  { value: "IDCR1G", label: "IDCR1G" },
  { value: "R59-02", label: "R59-02" },
  { value: "H1C", label: "H1C" },
  { value: "R2C", label: "R2C" },
  { value: "R8C", label: "R8C" },
  { value: "RCR1Z", label: "RCR1Z" },
  { value: "RS1F", label: "RS1F" },
  { value: "BNR1A", label: "BNR1A" },
  { value: "I1(IJ)", label: "I1(IJ)" },
  { value: "FMPR1C", label: "FMPR1C" },
  { value: "R3AB", label: "R3AB" },
  { value: "USR1C", label: "USR1C" },
  { value: "I2", label: "I2" },
  { value: "RCF1B", label: "RCF1B" },
  { value: "VS2", label: "VS2" },
  { value: "KD1C", label: "KD1C" },
  { value: "KD1B", label: "KD1B" },
  { value: "KP1B", label: "KP1B" },
  { value: "KR1B", label: "KR1B" },
  { value: "C1C", label: "C1C" },
  { value: "R4BC", label: "R4BC" },
  { value: "R4BC", label: "R4BC" },
  { value: "S1D", label: "S1D" },
  { value: "R3-07B", label: "R3-07B" },
  { value: "R1CB", label: "R1CB" },
  { value: "AGR3BR", label: "AGR3BR" },
  { value: "R1A", label: "R1A" },
  { value: "M3B", label: "M3B" },
  { value: "R3A", label: "R3A" },
  { value: "R4C", label: "R4C" },
  { value: "DB-02", label: "DB-02" },
  { value: "R7C", label: "R7C" },
  { value: "M1C", label: "M1C" },
  { value: "B1C", label: "B1C" },
  { value: "B1A", label: "B1A" },
  { value: "R1AAA", label: "R1AAA" },
  { value: "H1B", label: "H1B" },
  { value: "P9-02", label: "P9-02" },
  { value: "P1-02(B)", label: "P1-02(B)" },
  { value: "BNR1C", label: "BNR1C" },
  { value: "RS1D", label: "RS1D" },
  { value: "USR1D", label: "USR1D" },
  { value: "B3B", label: "B3B" },
  { value: "KS1C", label: "KS1C" },
  { value: "KB1B", label: "KB1B" },
  { value: "R3BC", label: "R3BC" },
  { value: "R1D-B", label: "R1D-B" },
  { value: "S1B", label: "S1B" },
  { value: "O1C", label: "O1C" },
  { value: "R1AAAAA", label: "R1AAAAA" },
  { value: "R59-03", label: "R59-03" },
  { value: "P1C", label: "P1C" },
  { value: "R3C", label: "R3C" },
  { value: "M1B", label: "M1B" },
  { value: "NA-DIA", label: "NA-DIA" },
  { value: "P1A", label: "P1A" },
  { value: "P1B", label: "P1B" },
  { value: "R3D", label: "R3D" },
  { value: "T4B", label: "T4B" },
  { value: "R2A", label: "R2A" },
  { value: "P1-01(A)", label: "P1-01(A)" },
  { value: "T1B", label: "T1B" },
  { value: "P1-02", label: "P1-02" },
  { value: "M3CL", label: "M3CL" },
  { value: "BNP1C", label: "BNP1C" },
  { value: "BNB1C", label: "BNB1C" },
  { value: "BLACK", label: "BLACK" },
  { value: "R5AA", label: "R5AA" },
  { value: "SI1", label: "SI1" },
  { value: "KA1C", label: "KA1C" },
  { value: "KC1C", label: "KC1C" },
  { value: "KR1C", label: "KR1C" },
  { value: "BROWN-C4-C6", label: "BROWN-C4-C6" },
  { value: "RS1E", label: "RS1E" },
  { value: "B1CL", label: "B1CL" },
  { value: "RS1C", label: "RS1C" },
  { value: "R1F", label: "R1F" },
  { value: "B1D", label: "B1D" },
  { value: "B1B", label: "B1B" },
  { value: "M1AAAA", label: "M1AAAA" },
  { value: "T5C", label: "T5C" },
  { value: "R1EB", label: "R1EB" },
  { value: "R1G", label: "R1G" },
  { value: "S3B", label: "S3B" },
  { value: "S3CL", label: "S3CL" },
  { value: "BNR1CB", label: "BNR1CB" },
  { value: "BNR1B", label: "BNR1B" },
  { value: "R1R", label: "R1R" },
  { value: "DUR1EB", label: "DUR1EB" },
  { value: "S1A", label: "S1A" },
  { value: "MIX", label: "MIX" },
  { value: "R7AA", label: "R7AA" },
  { value: "KC1B", label: "KC1B" },
  { value: "D1B", label: "D1B" },
  { value: "TLB-C2-C3", label: "TLB-C2-C3" },
  { value: "R1AA-GH", label: "R1AA-GH" },
  { value: "R59BL18", label: "R59BL18" },
  { value: "R1E-AR", label: "R1E-AR" },
  { value: "AGKR4C", label: "AGKR4C" },
  { value: "R1D", label: "R1D" },
  { value: "T1D", label: "T1D" },
  { value: "R9-02", label: "R9-02" },
  { value: "DB-03", label: "DB-03" },
  { value: "I1(HI)", label: "I1(HI)" },
  { value: "R3E", label: "R3E" },
  { value: "T4CL", label: "T4CL" },
  { value: "S1C", label: "S1C" },
  { value: "T1CL", label: "T1CL" },
  { value: "X59Z", label: "X59Z" },
  { value: "RCR1B", label: "RCR1B" },
  { value: "M3C", label: "M3C" },
  { value: "B1-02(B)", label: "B1-02(B)" },
  { value: "RS1G", label: "RS1G" },
  { value: "R4E", label: "R4E" },
  { value: "BNP1CB", label: "BNP1CB" },
  { value: "BNB1CB", label: "BNB1CB" },
  { value: "R1DL", label: "R1DL" },
  { value: "BNR1D", label: "BNR1D" },
  { value: "USR1A", label: "USR1A" },
  { value: "LB-C3-C4", label: "LB-C3-C4" },
  { value: "R3BD", label: "R3BD" },
  { value: "FMPR1DI1-I2(GH)", label: "FMPR1DI1-I2(GH)" },
  { value: "I-1(GHI)", label: "I-1(GHI)" },
];

const subAreaConfigurations = {
  9: {
    factoryCode: "IKR06",
    currency: "INR",
    goldButtonText: "GM",
    silverButtonText: "GM",
    platinumButtonText: "GM",
    selectedRadio: "STYLE",
    selectedQualityRadio: "INTERNALQUALITY",
  },
  1: {
    factoryCode: "CNPY_C02",
    currency: "USD",
    goldButtonText: "OZ",
    silverButtonText: "OZ",
    platinumButtonText: "OZ",
    selectedRadio: "DESIGN",
    selectedQualityRadio: "INTERNALQUALITY",
  },
  18: {
    factoryCode: "TCF_FAC",
    currency: "USD",
    goldButtonText: "OZ",
    silverButtonText: "OZ",
    platinumButtonText: "OZ",
    selectedRadio: "DESIGN",
    selectedQualityRadio: "INTERNALQUALITY",
  },
  // Add more configurations for other subAreas as needed
};

const menuItems = {
  admin: [
    { path: "/profile", label: "Users" },
    { path: "/Logs", label: "Logs" },
    { path: "/Masters", label: "Masters" },
    { path: "/IpAddress", label: "IpAddress" },
    { path: "/Images", label: "Images" },
    { path: "/designExtractor", label: "Design Extractor" },
    { path: "/PricingTable", label: "Pricing" },
    { path: "/PricingChart", label: "Pricing Chart" },
    { path: "/cron-list", label: "Automation" },

  ],
  editor: [
    { path: "/Masters", label: "Masters" }
  ],
  viewer: [
    { path: "/Logs", label: "Logs" },
    { path: "/Masters", label: "Masters" }
  ],
  user: [
    { path: "/PricingTable", label: "Pricing" },
    { path: "/PricingChart", label: "Pricing Chart" }
  ]
};



export {
  softwareOptions,
  paginationList,
  statusList,
  booleanList,
  unitList,
  pricingNoList,
  currencyList,
  metalColorList,
  columnData,
  factoryCodeList,
  caratNonEditableList,
  logsColumnData,
  goldOptions,
  rulesColumnData,
  silverOptions,
  platinumOptions,
  internalQulityList,
  subAreaConfigurations,
  columnPricingTableData,
  pricingQualityList,
  qualityOptionList,
  menuItems
};




